import { useState } from 'react';
import './JoinPage.css';
import elbyMockup from '../assets/mailLetters.png';
import elbySignature from '../assets/elby.png';
import BeforeFooter from "../components/layout/BeforeFooter";
import { API_URL } from '../config/api';

function JoinPage() {
  const [form, setForm] = useState({ name: "", email: "" });
  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    try {
      const response = await fetch(`${API_URL}/subscribe/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (data.success) {
        setStatus("💌 You're in! Your first letter will find you soon.");
        setForm({ name: "", email: "" });
        setSubmitted(true);
      } else {
        setStatus("Failed to subscribe. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setStatus("Error connecting to server.");
    }
  };

  return (
    <>
      <section className="elby-section">

        {/* Background blobs */}
        <div className="elby-blob elby-blob-1" />
        <div className="elby-blob elby-blob-2" />
        <div className="elby-blob elby-blob-3" />

        <div className="elby-container">

          {/* Left Image — hidden on mobile, shown on desktop */}
          <div className="elby-left">
            <img src={elbyMockup} alt="Preview of letters" className="elby-image" />
          </div>

          {/* Mobile image — shown only on mobile at top */}
          <div className="elby-mobile-image">
            <img src={elbyMockup} alt="Preview of letters" className="elby-image-mobile" />
          </div>

          {/* Right Content */}
          <div className="elby-right">
            <h1 className="elby-title">Letters from Elby</h1>
            <p className="elby-description">
              A soft letter every few weeks — a quiet pause filled with thoughts, books, and gentle reminders to come back to yourself.
            </p>

            {!submitted ? (
              <form className="elby-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <button type="submit">Subscribe</button>
              </form>
            ) : null}

            {status && (
              <p className={`elby-status ${submitted ? 'success' : 'loading'}`}>
                {status}
              </p>
            )}

            <p className="elby-note">You can unsubscribe anytime. Your inbox is safe with me. ✨</p>
            <img src={elbySignature} alt="Elby Signature" className="elby-signature" />
          </div>

        </div>
      </section>
      <BeforeFooter />
    </>
  );
}

export default JoinPage;